<template>
  <!-- <header :class="{ 'dont_print': store.state.customer.printing }"> 
    <div class="container-lg">
      <div class="container-wrapper f-direction d-flex align-items-center">
        <div class="d-inline-flex w-100 f-justify-content-first padding-0-5 width-300">
          <div id="company-logo" :title="store.state.company.website_name">
            <router-link to="/"><img :src="store.state.company.logo_url" alt="" height="70px"></router-link>
          </div>
        </div>
        <div class="d-inline-flex w-100 f-justify-content-second align-items-center">
            <HeaderIconValComponent v-bind:id="'company-work-hours'"
                                    :icon="'fa-regular fa-clock'"
                                    :info="store.state.company.working_hours"></HeaderIconValComponent>
          <div class="company-phone-display">
            <HeaderIconValComponent v-bind:id="'company-phone'"
                                    :icon="'fa-solid fa-phone'"
                                    :mobile-number="$filters.phoneBeautify(store.state.company.phone_number)"
                                    ></HeaderIconValComponent>

          </div>
          <div id="languages-container-wrapper" v-if="languages.length && locale" :set="currentLanguage = languages.find((l) => l.iso === locale)">
            <a href="#" @click.prevent="languagesDropdown.toggle">

              <country-flag :iso="currentLanguage.iconIso" mode="rounded" :title="currentLanguage.name" />
              <div class="caret-container" v-if="languages.length > 1">
                <font-awesome-icon v-if="! languagesDropdown.isOpen" icon="fa-solid fa-caret-down" />
                <font-awesome-icon v-if="languagesDropdown.isOpen" icon="fa-solid fa-caret-up" />
              </div>
            </a>
            <div id="language-dropdown-container"
                 ref="target"
                 v-if="languages.length > 1"
                 v-on-click-outside="languagesDropdown.onOutside"
                 :class="! languagesDropdown.isOpen ? 'd-none' : ''"
            >
              <ul>
                <li v-for="lang in languages" :class="{'active': lang.iso === locale}">
                  <a href="#" @click.prevent="languagesDropdown.onSelect(lang)">
                    <country-flag :iso="lang.iconIso" mode="rounded" />
                    <span class="font-big text-uppercase">{{lang.iso}}</span>
                  </a>
                </li>
              </ul>
            </div>

          </div>
          <div id="login-button-container">
            <router-link :to="! store.getters['customer/isLoggedIn'] ? routes.LOGIN : routes.PROFILE" :title="store.getters['customer/isLoggedIn'] ? $t('profile') : $t('login')">
                <ButtonComponent class="button-container-white login-button" v-show="parseInt(store.state.socialAuth.enable_login_setting) === 1">
                  <template #btnContent>
                    <template v-if="! store.getters['customer/isLoggedIn']">
                      {{ $t('login') }}
                    </template>
                    <template v-else>
                      <template v-if="store.state.customer.company_name">
                        {{ store.state.customer.company_name }}
                      </template>
                      <template v-else>
                        {{ store.state.customer.first_name ?? '' }} {{ store.state.customer.last_name ?? '' }}
                      </template>
                    </template>
                  </template>
                </ButtonComponent>

                <ButtonComponent class="mob-button-container-white mob-login-button" :class="{'mob-profile-button': store.getters['customer/isLoggedIn']}">
                  <template #btnContent>
                    <font-awesome-icon icon="fa-solid fa-user" />
                  </template>
                </ButtonComponent>
            </router-link>
          </div>

        </div>
      </div>
    </div>
  </header>-->
</template>

<script lang="ts">
import './headerTop.scss';
// @ts-ignore
import HeaderIconValComponent from "../headerIconValComponent/HeaderIconValComponent.vue";

import { defineComponent } from 'vue';
import {useStore} from 'vuex';
import { computed } from 'vue';
// @ts-ignore
import type {ILanguagesDropdown} from "@/interfaces/ILanguagesDropdown.interface";
// @ts-ignore
import type {ILanguage} from "@/interfaces/ILanguage.interface";
// @ts-ignore
import store from "../../../store";
// @ts-ignore
import ButtonComponent from "../../Button/ButtonComponent";
import {routesConst} from "../../../routes";

export default defineComponent({
  components: {ButtonComponent, HeaderIconValComponent },
  props: {},
  setup() {
    const store = useStore();

    return {
      store,
      languages: computed(() => store.state.general.languages),
      locale: computed(() => store.state.general.locale),
    };
  },
  data: function () {

    return {
      routes: routesConst,
      languagesDropdown: {} as ILanguagesDropdown,
      count: 0
    };
  },
  mounted() {
    // ...
  },
  created() {
    this.languagesDropdown = {
      isOpen: false,
      toggle: (): void => {
        const _this = this.languagesDropdown;

        _this.isOpen = !_this.isOpen;
      },
      onSelect: (lang: ILanguage): void => {
        const _this = this.languagesDropdown;

        if (lang.iso === this.locale as unknown) {
          _this.hide();
          return;
        }

        store.commit('general/SET_LOCALE', lang.iso);

        if (typeof (Storage)) {
          localStorage.setItem("locale", lang.iso);
        }

        window.location.reload();

        _this.hide();
      },
      hide: () => {
        const _this = this.languagesDropdown;

        _this.isOpen = false;
      },
      onOutside: (e) => {
        const _this = this.languagesDropdown;

        if (!_this.isOpen) {
          return;
        }
        const element = document.getElementById('languages-container-wrapper');

        if (! element || (e.target !== element && ! element.contains(e.target))) {
          _this.hide();
        }
      }
    } as ILanguagesDropdown;
  },
});
</script>

<style scoped type="text/css" media="print">
.dont_print {
  display: none !important;
}
</style>